import { useThemeColor } from "@/hooks/useThemeColor";
import { forwardRef } from "react";
import { ScrollView, ScrollViewProps } from "react-native";

export type TScrollViewProps = ScrollViewProps & {
  lightColor?: string;
  darkColor?: string;
  padding?: number;
};

// eslint-disable-next-line react/display-name
export const BodyScrollView = forwardRef<any, TScrollViewProps>(
  ({ lightColor, darkColor, padding = 16, ...props }, ref) => {
    const backgroundColor = useThemeColor(
      { light: lightColor, dark: darkColor },
      "background"
    );

    return (
      <ScrollView
        automaticallyAdjustsScrollIndicatorInsets
        contentInsetAdjustmentBehavior="automatic"
        showsVerticalScrollIndicator={false}
        showsHorizontalScrollIndicator={false}
        contentInset={{ bottom: 0 }}
        scrollIndicatorInsets={{ bottom: 0 }}
        {...props}
        ref={ref}
        style={[props.style, { backgroundColor, padding: padding }]}
      />
    );
  }
);
